'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueCarousel = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _multitrack = require('helpers/multitrack');

var _ResponsiveCarousel = require('../ResponsiveCarousel/ResponsiveCarousel');

var _StudioListItem = require('../StudioListItem/StudioListItem');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VenueCarousel = exports.VenueCarousel = function VenueCarousel(_ref) {
  var elements = _ref.elements,
      header = _ref.header,
      loading = _ref.loading,
      nolink = _ref.nolink,
      type = _ref.type,
      showCount = _ref.showCount;
  return _react2.default.createElement(
    _ResponsiveCarousel.ResponsiveCarousel,
    {
      extraClass: (0, _classnames2.default)('carousel--venues', (0, _defineProperty3.default)({}, 'carousel--venues-' + type, type)),
      handleDwell: function handleDwell() {
        return (0, _multitrack.ga)('Venue Details', 'View Module', 'venues_' + type, 0, { nonInteraction: true });
      },
      header: header,
      loading: loading,
      type: type
    },
    (elements || []).slice(0, 20).map(function (item) {
      return _react2.default.createElement(_StudioListItem.StudioListItem, {
        type: type,
        key: item.id,
        venueId: item.id,
        activities: item.activities,
        imageUrl: item.images && item.images.default || '',
        name: item.name,
        subtitle: item.subtitle,
        hood: item.location && item.location.name || '',
        alias: item.alias,
        rating: item.ratings && item.ratings.mean > 0 ? item.ratings.mean : -1,
        nolink: nolink,
        showRatingNumber: !showCount,
        count: showCount && item.ratings.display_total + ' ratings'
      });
    })
  );
};

VenueCarousel.propTypes = {
  elements: _propTypes2.default.array,
  header: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  nolink: _propTypes2.default.bool,
  type: _propTypes2.default.string,
  showCount: _propTypes2.default.bool
};